import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const RoleRoute = ({ roles, children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return <div className="p-8 text-muted-foreground">Cargando...</div>;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (roles && !roles.includes(user.role)) {
        // route them to their natural home
        const home = user.role === "technician" ? "/tech" : user.role === "client" ? "/portal" : "/admin";
        return <Navigate to={home} replace />;
    }
    return children;
};

export default RoleRoute;
